module.exports = __webpack_public_path__ + "img/开启代购.665ba211.png";